import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, unref as _unref, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-52c53c16"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "identity-informaiton-wrap" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "证件信息", -1))
const _hoisted_3 = { class: "content" }
const _hoisted_4 = {
  key: 0,
  class: "card-item-operator-wrap van-hairline--bottom"
}
const _hoisted_5 = ["onClick"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "line" }, null, -1))
const _hoisted_7 = ["onClick"]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "line" }, null, -1))
const _hoisted_9 = ["onClick"]

import { withDefaults, ref } from 'vue'
import { CardItemRenderType, CardTabItemRenderType } from '@/types/my-credentials'
import {
  judgeCetifateOpearatorApplyBtnCanLight,
  judgeCetifateOpearatorDownloadBtnCanLight,
  judgeIsNewUavOperatorCertificate,
  judgeCetifateIsUavOperator,
  judgeCetifateIsDiaoyunOperater,
} from '@/compositions/my-crendentials/index'
import { useUserPermissionVerify } from '@/compositions/useUserAuthPermission'
import { downLoadCredential } from '@/apis/my-credentials'
import { Toast } from 'vant'
import AppHost from '@/utils/app'
import wxHost from '@/utils/wx'

import { useRouter } from 'vue-router'


import { defineComponent } from 'vue'
import { Tabs, Tab, Dialog } from 'vant'
import CardItem from './card-item.vue'
const __default__ = defineComponent({
  components: { Tabs, Tab, CardItem },
  name: 'identity-informaiton',
  methods: {},
})

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    status: { default: 0 },
    photo: null,
    cardData: null
  },
  emits: ["upload"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'upload'): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as { status: number, photo: string | null, cardData: Array<CardTabItemRenderType> };

const $router = useRouter()


const { beforeAuthOpenWxMiniProgramHandle } = useUserPermissionVerify()



const active = ref(0)

// 判断是否可以
const gotoDetailHandle = (item: CardItemRenderType) => {
  if (!item.isActive) {
    return
  }
  $router.push({
    name: 'credentials-detail',
    query: {
      type: item.type,
    },
  })
}

const downloadHandle = async (item: CardItemRenderType) => {
  if (!judgeCetifateOpearatorDownloadBtnCanLight(item, props.status)) {
    return
  }
  let toast = Toast({
    type: 'loading',
    message: '下载中...',
    forbidClick: true,
    duration: 0,
  })
  try {
    let url = ''
    if (judgeCetifateIsUavOperator(item.type)) {
      url = item.license_seal_image_url
    } else if (judgeCetifateIsDiaoyunOperater(item)) {
      url = item.license_image_url
    } else {
      let data = await downLoadCredential({
        type: item.type,
      })
      url = data.file_url
    }

    AppHost.openBrowser(url, true)
    toast.clear()
  } catch (e: any) {
    Toast.fail(e.message)
  }
}

const uploadHandle = () => {
  console.log('uploadHandle')
  emit('upload')
}

function applyHandle(item: CardItemRenderType) {
  if (!judgeCetifateOpearatorApplyBtnCanLight(item, props.status)) {
    return
  }
  // 判断是否有申请过
  if (item.is_apply === 1) {
    Dialog.alert({
      title: '提示',
      className: 'tip-dialog',
      message: '您有尚在申请制证或制作中的证件，无需重复申请。',
      confirmButtonColor: 'rgba(0, 195, 120, 1)',
      confirmButtonText: '知道了',
    })
    return
  } else if (!wxHost.isMiniprogram) {
    Dialog.alert({
      title: '提示',
      className: 'tip-dialog',
      message: '请前【极飞服务】小程序申请证件。',
      confirmButtonColor: 'rgba(0, 195, 120, 1)',
      confirmButtonText: '知道了',
    })
    return
  }
  beforeAuthOpenWxMiniProgramHandle({
    id: 'gh_68b32d3107f6',
    path: `/pages--train/my_license_apply_form?types=${Number(item.type)}`,
    version: process.env.NODE_ENV === 'production' ? 0 : 1,
  })
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_unref(Tabs), {
        class: "tab-wrap",
        active: active.value,
        "onUpdate:active": _cache[0] || (_cache[0] = ($event: any) => ((active).value = $event)),
        "title-active-color": "#00C378",
        "swipe-threshold": 4
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.cardData, (cardItem, index) => {
            return (_openBlock(), _createBlock(_unref(Tab), {
              title: cardItem.title,
              key: index,
              style: {"padding-top":"16px"}
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(cardItem.cardData, (item, i) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "card-content",
                    key: i
                  }, [
                    _createVNode(CardItem, {
                      cardItem: item,
                      photo: __props.photo,
                      status: __props.status,
                      onUpload: uploadHandle
                    }, null, 8, ["cardItem", "photo", "status"]),
                    (item.isActive)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                          _createElementVNode("div", {
                            class: _normalizeClass({
                  active: _unref(judgeCetifateOpearatorApplyBtnCanLight)(item, props.status),
                }),
                            onClick: ($event: any) => (applyHandle(item))
                          }, " 申请实体证件 ", 10, _hoisted_5),
                          _hoisted_6,
                          _createElementVNode("div", {
                            class: _normalizeClass({
                  active: _unref(judgeCetifateOpearatorDownloadBtnCanLight)(item, props.status),
                }),
                            onClick: ($event: any) => (downloadHandle(item))
                          }, " 下载电子证 ", 10, _hoisted_7),
                          _hoisted_8,
                          _createElementVNode("div", {
                            class: _normalizeClass({ active: item.isActive }),
                            onClick: ($event: any) => (gotoDetailHandle(item))
                          }, "证件详情", 10, _hoisted_9)
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                }), 128))
              ]),
              _: 2
            }, 1032, ["title"]))
          }), 128))
        ]),
        _: 1
      }, 8, ["active"])
    ])
  ]))
}
}

})